export default () => ({
    canScrollToLeft: false,
    canScrollToRight: false,
    scrolling: false,
    getRemainingScrollToRight() {
        const { scrollWidth, scrollLeft, clientWidth } = this.$refs.carousel;

        return scrollWidth - (scrollLeft + clientWidth) || 0;
    },
    getRemainingScrollToLeft() {
        return this.$refs.carousel.scrollLeft || 0;
    },
    showMore(direction) {
        const container = this.$refs.carousel;
        const remainingWidth = this.getRemainingWidth(direction);
        const widthToScroll = Math.min(container.clientWidth - 150, remainingWidth);

        if (this.scrolling || !widthToScroll) {
            return;
        }

        container.scrollBy({
            left: direction === 'left' ? -widthToScroll : widthToScroll,
            top: 0,
            behavior: 'smooth'
        });

        this.callUpdateCanScroll();
    },
    callUpdateCanScroll() {
        const container = this.$refs.carousel;

        if ('onscrollend' in window) {
            container.addEventListener('scrollend', () => {
                this.updateCanScroll();
                this.scrolling = false;
            }, { once: true });
        }
    },
    handleScrollSelf() {
        this.updateCanScroll();
    },
    getRemainingWidth(direction) {
        const container = this.$refs.carousel;

        return direction === 'left'
            ? container.scrollLeft
            : (container.scrollWidth - container.clientWidth - container.scrollLeft);
    },
    updateCanScroll() {
        this.$nextTick(() => {
            this.canScrollToLeft = this.getRemainingScrollToLeft() > 0;
            this.canScrollToRight = this.getRemainingScrollToRight() > 0;
        });
    },
    init() {
        this.updateCanScroll();
    }
});
